import React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { Link, Text, useAppTheme } from '@workwhile/ui'
import { ArrowRight } from 'lucide-react'
import { useAssociatedPositionsContextValue } from '../../context/AssociatedPositionsProvider'

export type AssociatedPositions = ReturnType<
  typeof useAssociatedPositionsContextValue
>['state']['items']

const PositionIdColumn: ColumnDef<AssociatedPositions[number]> = {
  header: 'Position ID',
  accessorKey: 'id',
  minSize: 100,
  maxSize: 100,
  cell: ({ row }) => {
    const { id } = row.original

    return <Text>{id}</Text>
  },
}

const PositionNameColumn: ColumnDef<AssociatedPositions[number]> = {
  header: 'Position Name',
  accessorKey: 'name',
  minSize: 200,
  cell: ({ row }) => {
    const { name } = row.original

    return <Text>{name}</Text>
  },
}

const CompanyColumn: ColumnDef<AssociatedPositions[number]> = {
  header: 'Company',
  accessorKey: 'company.name',
  minSize: 200,
  cell: ({ row }) => {
    const { company } = row.original

    return (
      <Text>
        {company.name} (
        <Link to={`/companies/${company.id}`}>{company.id}</Link>)
      </Text>
    )
  },
}

const MustHaveColumn: ColumnDef<AssociatedPositions[number]> = {
  header: 'Must Have',
  accessorKey: 'mustHave',
  minSize: 100,
  maxSize: 100,
  cell: ({ row }) => {
    const { mustHave } = row.original

    return <Text>{mustHave ? 'Yes' : 'No'}</Text>
  },
}

export const selectableColumns = [
  {
    id: 'positionId',
    label: 'Position ID',
    columnDef: PositionIdColumn,
  },
  {
    id: 'positionName',
    label: 'Position Name',
    columnDef: PositionNameColumn,
  },
  {
    id: 'company',
    label: 'Company',
    columnDef: CompanyColumn,
  },
  {
    id: 'mustHave',
    label: 'Must Have',
    columnDef: MustHaveColumn,
  },
] as const

export const DetailColumn: ColumnDef<AssociatedPositions[number]> = {
  header: 'Detail',
  size: 85,
  cell: ({ row }) => {
    const { colors } = useAppTheme()
    return (
      <Link to={`/positions/${row.original.id}`}>
        View <ArrowRight size={14} color={colors.primary} />
      </Link>
    )
  },
}
